import React from 'react';

const DownArrow = ({ display }) => {
  return (
    <svg
      className={`${display ? `rotate-180` : ``} duration-300`}
      width='21'
      height='13'
      viewBox='0 0 21 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M19.5002 1.99215L10.4983 11.0025L1.488 2.00062'
        stroke='white'
        stroke-width='2.58333'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default DownArrow;
